"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRoleStats = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ROLE_STATS_QUERY = (0, graphql_tag_1.default) `
  query RoleStatsQuery($workspace: ID!, $user: ID!, $referenceDate: Datetime) {
    role(workspace: $workspace, user: $user) {
      stats(referenceDate: $referenceDate) {
        monthContractMinutes
        monthPlannedMinutes
        monthOverTimeMinutes
        balancingPeriodContractMinutes
        balancingPeriodPlannedMinutes
        yearVacationMinutes
        yearVacationRemainingMinutes
        yearVacationDays
        yearVacationRemainingDays
        yearTimeOffs {
          categoryId
          minutes
          minutesRemaining
          minutesMaximum
          days
          daysRemaining
          daysMaximum
        }
      }
    }
  }
`;
const requestRoleStats = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(ROLE_STATS_QUERY, {
        variables,
    });
    if ((0, util_1.isValue)(errors)) {
        return errors[0];
    }
    return data?.role.stats;
};
exports.requestRoleStats = requestRoleStats;
// async function requestRoleStats(variables, token) {
//   const response = await fetchRequest({
//     variables,
//     query: ROLE_STATS_QUERY,
//     token,
//   })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('role-stats', errors)
//   }
//   return data.role.stats
// }
exports.default = exports.requestRoleStats;
